import * as React from 'react';
import { Box, Colors, Metrics } from '@origin-digital/style-guide';
// @ts-ignore
import { highlightKeywords } from '@origin-digital/utils';
import { SuggestionProps } from './Suggestions.types';

const ListItem = Box.extend`
  display: block;
  width: 100%;
  padding: ${Metrics.Spacing.P_Y_XXS}px ${Metrics.Spacing.GUTTER_SM}px;
  font-size: ${Metrics.FontSizes.BODY}px;
  line-height: ${Metrics.LineHeights.BODY}px;
  color: ${Colors.GREY};
  cursor: pointer;

  &:hover {
    background-color: ${Colors.GREY24};
    outline: none;
  }
`;

const Suggestion: React.StatelessComponent<SuggestionProps> = ({ ...props }: SuggestionProps) => {
  const { item, label, query, onClick, ['data-id']: dataId } = props;

  return (
    <ListItem onClick={e => onClick(e, item)} data-id={dataId}>
      {query ? highlightKeywords(query, label, {}) : label}
    </ListItem>
  );
};

export { Suggestion as default };
